export default __webpack_public_path__ + "static/media/gridImg2.789bdb5b.jpg";